<template>
    <div class="goods-form">
        <veui-form ref="addCuleForm" :data="formData">
            <veui-field
                field="lawyer_name"
                name="lawyer_name"
                label="目标律师"
                class="veui-field-required"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请选择目标律师',
                    },
                ]"
            >
                <lawyer-selector v-model="selectedLawyer" :disabled-days="0"/>
            </veui-field>
            <veui-field
                name="num"
                label="加购数量"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请输入加购数量',
                        triggers: 'change',
                    },
                ]"
            >
                <div>
                    <veui-number-input
                        v-model="formData.num"
                        ui="m"
                        :min="10"
                        placeholder="请输入加购数量"
                        style="width: 300px;"
                    />
                    <div class="tips">10条起购</div>
                </div>
            </veui-field>
            <veui-field name="price" label="加购单价">
                <veui-input :value="price / 100" :readonly="true"></veui-input>
            </veui-field>
            <veui-field name="total" label="订单总额">
                <veui-input :value="total / 100" :readonly="true"></veui-input>
            </veui-field>
            <veui-field v-if="selectedLawyer" name="tip">
                <div class="tip-field">
                    该律师本月累计加购线索量：<span class="tip-num">{{
                        clueAdditionalQuota
                    }}</span>，累计加购金额：¥
                    <span class="tip-num">{{ clueAdditionalQuotaAmount }}</span>
                </div>
            </veui-field>
            <veui-field
                name="isAgree"
                label=""
                :rules="[
                    {
                        name: 'required',
                        trigger: 'change',
                        value: true,
                        message: '请阅读并勾选协议',
                    },
                ]"
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null">
                    我已阅读并同意<span
                        class="goods-form-rule"
                        @click.stop="openRule"
                    >《{{ agreementInfo.name }}》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 律临线索加购包
 * @author
 */

import isBoolean from 'lodash/isBoolean';
import {Form, Field, NumberInput, Input, Checkbox} from 'veui';
import 'veui-theme-dls-icons/exclamation-circle';
import 'veui-theme-dls-icons/building';
import 'veui-theme-dls-icons/tag';
import LawyerSelector from '@/components/firm/lawyer-selector';

export default {
    name: 'goodsFormAddClue',
    props: {
        goodsInfo: {
            type: Object,
            default: () => {}
        },
        agreementInfo: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-number-input': NumberInput,
        'veui-checkbox': Checkbox,
        'lawyer-selector': LawyerSelector
    },
    data() {
        return {
            formData: {},
            selectedLawyer: null,
            clueAdditionalQuota: '-',
            clueAdditionalQuotaAmount: '-'
        };
    },
    computed: {
        curGoodsInfo() {
            return this.goodsInfo.clue_quota || {};
        },
        total() {
            const {price, formData} = this;
            if (price > 0 && formData.num > 0) {
                return price * formData.num;
            }
            return '0';
        },
        price() {
            const {curGoodsInfo} = this;
            if (curGoodsInfo.price > 0) {
                const discount = curGoodsInfo.discount || 10;
                return ((curGoodsInfo.price * discount) / 10).toFixed(2);
            }
            return '0';
        }
    },
    watch: {
        selectedLawyer(newVal) {
            const lawyer = newVal || {};
            this.formData.lawyer_name = lawyer.name;
            this.formData.qc_core_no = lawyer.qc_core_no;
            this.$refs.addCuleForm.validate(['lawyer_name']);
            this.getCustomerPrivilege();
        }
    },
    methods: {
        getCustomerPrivilege() {
            if (!this.formData.qc_core_no) {
                return;
            }
            this.$http
                .get('/bp/firm/clue_quota_buy_info', {
                    params: {qc_core_no: this.formData.qc_core_no}
                })
                .then(res => {
                    if (+res.code === 0 && res.data) {
                        const {num, total_amount} = res.data;
                        this.clueAdditionalQuota = num;
                        this.clueAdditionalQuotaAmount = total_amount / 100;
                    }
                });
        },
        sumbitForm() {
            this.$refs.addCuleForm.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                    this.$emit('nextStep', false);
                }
            });
        },
        postData() {
            const {price, formData} = this;
            this.$http
                .post('/bp/api/product/preorder', {
                    product_type: 1000,
                    num: formData.num,
                    qc_core_no: formData.qc_core_no,
                    agreement_ids: this.agreementInfo.id,
                    unique_id: '' + Math.round(new Date().getTime() / 1000) // 下单时间
                })
                .then(res => {
                    if (+res.code === 0 && res.data) {
                        const {order_info = {}, product_info = {}} = res.data;

                        const order = {
                            name: '线索额外量',
                            lawyer: formData.lawyer_name,
                            qcCoreNo: formData.qc_core_no,
                            price: '¥' + price / 100,
                            shouldPayAmount:
                                '¥' + product_info.should_pay_amount / 100,
                            pay_url: order_info.order_info_url
                        };
                        this.$emit('setGoodsFn', 'goodsOrder', order);
                        this.$emit('nextStep', true);
                    }
                    else if (+res.code !== 0) {
                        this.$Message.error(
                            res.msg || '网络错误，请稍后重试！'
                        );
                    }
                });
        },
        openRule() {
            window.open(this.agreementInfo.url);
        }
    }
};
</script>

<style scoped lang="less">
.goods-form {
    .tips {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #9d9d9d;
        line-height: 12px;
        font-weight: 400;
        margin-top: 12px;
    }

    /deep/ .veui-field-label {
        width: calc(5em + 6px);
    }

    .veui-field-no-label {
        margin-left: 12px;
    }

    .tip-field {
        margin-left: 9px;
        font-size: 14px;
        color: #282c33;
        display: flex;
        align-items: baseline;

        .tip-num {
            font-size: 24px;
            color: #282c33;
        }
    }
}
</style>
